// @ts-strict-ignore
import { ProjectVO } from '@project/model/vo/project.vo';
import { TextureConnectionInfoVO } from '@3d-scene/processor/texture-connection-info.vo';

export class PrintLabelingVO {
  public articleNo: string;
  public articleIdentity: number;
  public articleVersions: number[];
  public articleUsageIds: string[];
  public textCheckClass: string;
  public usePlotter: boolean = false;
  public exported: string;
  public project: ProjectVO;
  public textureConnectionInfos: TextureConnectionInfoVO[];
  public imageConnectionInfos: TextureConnectionInfoVO[];
  public selectedCutmarkOption: string = 'NONE';
  public forDirectPrinting: boolean;
}
